export const padronctc = [
    {
        "year": "2025",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/CTC/beneficiariosCTC2025.pdf",
    },
    {
        "year": "2024",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/CTC/beneficiariosCTC2024.pdf",
    },
    {
        "year": "2023",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/CTC/beneficiariosCTC2023.pdf",
    },
]